import { createFileRoute } from '@tanstack/react-router'
import { Logo } from '@/components/brand/logo'
import { Card } from '@/components/ui/card'

export const Route = createFileRoute('/setup')({ component: Setup })

function Setup() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center gap-6 px-4 py-10">
      <Logo on="theme" className="h-32" />
      <Card>
        <h1 className="text-2xl uppercase">Not connected yet</h1>
        <p className="mt-2 text-fg-muted">
          This build has no Supabase project configured. Copy <code>.env.example</code> to{' '}
          <code>.env.local</code>, fill in <code>VITE_SUPABASE_URL</code> and{' '}
          <code>VITE_SUPABASE_PUBLISHABLE_KEY</code>, then restart. See README.md.
        </p>
      </Card>
    </div>
  )
}
